/**
 * TEMPORARY KILL-SWITCH for "Continue with Google".
 *
 * The Google provider is not enabled in the Supabase project — the authorize
 * endpoint returns `400 "provider is not enabled"`, so clicking the button
 * bounces the user to a raw Supabase error page. Until Google OAuth is
 * configured (Google Cloud OAuth client + Supabase Auth → Providers + the
 * redirect allow-list), every "Continue with Google" button is hidden.
 *
 * The `onGoogle` handlers stay wired in each form; flip this to `true` once the
 * provider is live and the buttons reappear — no other changes needed.
 */
export const GOOGLE_OAUTH_ENABLED = false;
